<template>
	<div class="ing">
		<img v-if="imgType==='coding'" src="../../../assets/img/coding.png" style="width:431px;"/>
		<img v-if="imgType==='regUsering'" src="../../../assets/img/regUsering.png" style="width:300px;"/>
		<img v-if="imgType==='regPeting'" src="../../../assets/img/regPeting.png" style="width:300px;"/>
		<img v-if="imgType==='konging'" src="../../../assets/img/konging.png" style="width:271px;"/>
		<img v-if="imgType==='rebackCarding'" src="../../../assets/img/rebackCarding.png" style="width:300px;"/>
		<div class="text">{{text}}</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				
			}
		},
		computed:{
			imgType(){
				return this.$store.state.ing.imgType;
			},
			text(){
				return this.$store.state.ing.text;
			},
		},
		mounted(){
			
		},
		methods: {
			
		}
	}
</script>
<style scoped lang="scss">
.ing{
	position: relative;
	width:100%;
	height: 100%;
	background-color: #fff;
	text-align: center;
	img{
		margin-top:200px;
	}
	.text{
		font-size: 14px;color:$fontColor;margin:20px;
	}
}
</style>
